import styles from "./AboutPage.module.css";

export default function AboutPage() {
  return (
    <section className={styles.contentSection}>
      <h1 className={styles.mainTitle}>About Image Resizer and Compressor</h1>
      <p>
        <strong>ImageResizerAndCompressor</strong> is a free online tool that
        lets you make your image files smaller quickly while still providing
        image quality. If you are a web developer or have a blog or are a
        photographer, optimized images will load faster on your site and are
        beneficial for search engine optimization.
      </p>

      <h2>Why Compress Images?</h2>
      <p>
        Large images will load slower on your website and take up space.
        Compressed and resized images will load more quickly for the user,
        improve user experience, and save bandwidth for the user all while
        maintaining visual appearance.
      </p>

      <h2>How It Works</h2>
      <ol>
        <li>Upload the image (JPG, PNG, or WEBP).</li>
        <li>Choose your desired dimensions or compression level.</li>
        <li>Click the compress button to optimize the file.</li>
        <li>Instantly download the optimized file.</li>
      </ol>

      <h2>Features</h2>
      <ul>
        <li>100% free and online, nothing to sign up for.</li>
        <li>Support JPG, PNG, WEBP images.</li>
        <li>
          Maintain the quality of the original image while reducing the file
          size.
        </li>
        <li>Quick, safe, and works fine on mobile platforms.</li>
      </ul>

      <h2>Tips on Image Optimization</h2>
      <p>
        Always resize the images to your site layout before you upload them. Do
        not load unnecessarily large files. Always optimize and compress your
        images so that you know the files will not take forever to load without
        sacrificing an image's quality and speed. Using{" "}
        <strong>ImageResizerAndCompressor</strong>
        can make your life easier.
      </p>

      <p className={styles.finalNote}>
        Begin optimizing images now in order to achieve a faster, lighter, and
        more user-friendly site!
      </p>
    </section>
  );
}
